
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  checkoutWashBasinDimensions: {
    id: "Checkout.WashBasinDimensions",
    defaultMessage: "Wash basin dimensions"
  }, 
  checkoutPlateDimensionsWidth: {
    id: "Checkout.PlateDimensions.Width",
    defaultMessage: "Width"
  },
  checkoutPlateDimensionsDepth: {
    id: "Checkout.PlateDimensions.Depth",
    defaultMessage: "Depth"
  },
  checkoutTypeOfInstallation: {
    id: "Checkout.TypeOfInstallation",
    defaultMessage: "Type of Installation"
  },
  checkoutTypeOfInstallationLeft: {
    id: "Checkout.TypeOfInstallation.Left",
    defaultMessage: "Wall left",
  }, 
  checkoutTypeOfInstallationRight: {
    id: "Checkout.TypeOfInstallation.Right",
    defaultMessage: "Wall right",
  },
  checkoutTypeOfInstallationWith: {
    id: "Checkout.TypeOfInstallation.With",
    defaultMessage: "Wall left and right",
  },
  checkoutCornerDesign: {
    id: "Checkout.CornerDesign",
    defaultMessage: "Corner Design"
  },
  checkoutCornerDesignRadius: {
    id: "Checkout.CornerDesign.Radius",
    defaultMessage: "Radius 100 mm"
  },  
  checkoutCornerDesignBevel: {
    id: "Checkout.CornerDesign.Bevel",
    defaultMessage: "Bevel, 100 mm"
  },
  checkoutLeft: {
    id: "Checkout.Left",
    defaultMessage: "left"
  },
  checkoutRight: {
    id: "Checkout.Right",
    defaultMessage: "right"
  },
  orderPdf: {
    id: "Checkout.OrderPdf",
    defaultMessage: "Download configuration"
  },
  manufacturingPdf: {
    id: "Checkout.ManufacturingPdf",
    defaultMessage: "Download drawing"
  },
  apronBackSplashHeadline: {
    id: "Checkout.ApronBackSplash.Headline",
    defaultMessage: "Apron / Backsplash"
  },  
  apronBackSplashApron: {
    id: "Checkout.ApronBackSplash.Apron",
    defaultMessage: "Apron: {position} / {height} mm"
  },
  apronBackSplashSurgeEdge: {
    id: "Checkout.ApronBackSplash.SurgeEdge",
    defaultMessage: "Surge edge: {position} / Height: 3 mm."
  },
  apronBackSplash: {
    id: "Checkout.ApronBackSplash.apronBackSplash",
    defaultMessage: "Back splash: {position} - Height: {height} mm."
  },
  apronBackSplashPositionBack: {
    id: "ElementsPositionsBack.back",
    defaultMessage: "back"
  },
  apronBackSplashPositionFront: {
    id: "ElementsPositionsFront.front",
    defaultMessage: "front"
  },
  apronBackSplashPositionLeft: {
    id: "ElementsPositionsLeft.left",
    defaultMessage: "left"
  },
  apronBackSplashPositionRight: {
    id: "ElementsPositionsRight.right",
    defaultMessage: "right"
  },
  builtInPartsTitle: {
    id: "Checkout.BuiltInParts.BuiltInPartsTitle",
    defaultMessage: "Recesses / Built-in Parts",
  },
  builtInPartsDrillHoleForTaps: {
    id: "Checkout.BuiltInParts.BuiltInPartsDrillHoleForTaps",
    defaultMessage: "{qty}x Drill hole for taps",
  },
  builtInPartsDrillHoleForSoap: {
    id: "Checkout.BuiltInParts.BuiltInPartsDrillHoleForSoap",
    defaultMessage: "{qty}x Drill hole for Soap dispenser",
  },
  builtInPartsCutOut: {
    id: "Checkout.BuiltInParts.BuiltInPartsCutOut",
    defaultMessage: "{qty}x Cut out",
  },
  builtInPartsCutOutPaperTowelDispenser: {
    id: "Checkout.BuiltInParts.BuiltInPartsCutOutPaperTowelDispenser",
    defaultMessage: "{qty}x Cut out for paper towel dispenser",
  },
  builtInPartsCutOutTissueDispenser: {
    id: "Checkout.BuiltInParts.BuiltInPartsCutOutTissueDispenser",
    defaultMessage: "{qty}x Cut out for cosmetic tissue dispenser",
  },
  builtInPartsCutOutTowelRail: {
    id: "Checkout.BuiltInParts.BuiltInPartsCutOutTowelRail",
    defaultMessage: "{qty}x Cut out for towel rail",
  },
  surfaceTitle: {
    id: "Checkout.Surface.Title",
    defaultMessage: "Surface",
  },
  surfaceColor: {
    id: "Checkout.Surface.Color",
    defaultMessage: "Color: {color}",
  },
  surfaceGelCoat: {
    id: "Checkout.Surface.GelCoat",
    defaultMessage: "Gel coat on bottom side",
  },
  assemblyAccessoriesTitle: {
    id: "Checkout.AssemblyAccessories.Title",
    defaultMessage: "Assembly Accessories",
  }, 
  assemblyAccessoriesConsoles: {
    id: "Checkout.AssemblyAccessories.Consoles",
    defaultMessage: "{qty}x Console {part}",
  },
  assemblyAccessoriesAngleBar: {
    id: "Checkout.AssemblyAccessories.AngleBar",
    defaultMessage: "{qty}x Angle bar for mounting at side wall.",
  }, 
  assemblyAccessoriesSafetyCatch : {
    id: "Checkout.AssemblyAccessories.SafetyCatch",
    defaultMessage: "{qty}x Safety catch for mounting at back wall.",
  },
  generalInfoHeadline : {
    id: "Checkout.GeneralInfo.Headline",
    defaultMessage: "General",
  },
  generalInfoConfName : {
    id: "Checkout.GeneralInfo.ConfName",
    defaultMessage: "Congifuration Name: ",
  },
  totalPriceWashbasin : {
    id: "Checkout.TotalPrice.Washbasin",
    defaultMessage: "Washbasin",
  },
  totalPriceParts : {
    id: "Checkout.TotalPrice.Parts",
    defaultMessage: "Assembly parts",
  },
  totalPriceDeliveryCosts : {
    id: "Checkout.TotalPrice.DeliveryCosts",
    defaultMessage: "Delivery costs",
  },
  totalPriceVat : {
    id: "Checkout.TotalPrice.Vat",
    defaultMessage: "VAT",
  },
  totalPriceTotal : {
    id: "Checkout.TotalPrice.Total",
    defaultMessage: "Total",
  },
  totalPriceNote : {
    id: "Checkout.TotalPrice.Note",
    defaultMessage: "Note:",
  },
  totalPriceNoteText : {
    id: "Checkout.TotalPrice.NoteText",
    defaultMessage: "It is expected that 19 % VAT will apply again from 01.01.2021.",
  },
  troughCheckoutHeadline : {
    id: "Checkout.Trough.Headline",
    defaultMessage: "Trough",
  },
  troughCheckoutName : {
    id: "Checkout.Trough.Name",
    defaultMessage: "Name of trough:",
  },
  troughCheckoutQty : {
    id: "Checkout.Trough.Qty",
    defaultMessage: "Quantity:",
  },
  troughCheckoutDimensions : {
    id: "Checkout.Trough.Dimensions",
    defaultMessage: "Basin dimensions:",
  },
  white : {
    id: "ColorCheckout.white",
    defaultMessage: "white",
  },
  black : {
    id: "ColorCheckout.black",
    defaultMessage: "black",
  },
  'black-white' : {
    id: "ColorCheckout.blackWhite",
    defaultMessage: "black-white",
  },
  'light-gray' : {
    id: "ColorCheckout.lightGray",
    defaultMessage: "light-gray",
  },
  legalsLabel: {
    id: "HomeLink.legals",
    defaultMessage: "Terms and Conditions",
  },
  legalsLink: {
    id: "MetaNavigationLegals.legalsLink",
    defaultMessage: "https://kwc.com/en_GB/footer-pages/allgemeine-gesch%C3%A4ftsbedingungen_pro",
  }
});

export default MESSAGES;